import { useQuery } from '@tanstack/react-query';

import { statsApi } from '../stats.api';

export const useQueryGrantedGroups = () =>
  useQuery({
    queryKey: ['granted-groups'],
    queryFn: statsApi.getGrantedGroups,
  });
